export default __webpack_public_path__ + "static/media/yelp.2d94ea0f.png";